import styled from "@emotion/styled";

import { MergeWithOverwrite } from "src/common";

const IconSpan = styled.span((props: { height: number, width: number }) => ({
  display: 'inline-flex',
  height: props.height,
  width: props.width,
}))

export type BarcodeIconProps = MergeWithOverwrite<React.HtmlHTMLAttributes<HTMLSpanElement>, {
  width?: number,
  height?: number,
}>;

export const BarcodeIcon: React.FC<BarcodeIconProps> = ({ width = 111, height = 90, ...props }) => (
  <IconSpan {...props} height={height} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width={width} height={height} viewBox="0 0 111 90">
      <desc></desc>
      <rect x="0" y="0" width={width} height={height} style={{ fill: '#ffffff' }} />
      <line fill="none" style={{ stroke: '#000000', strokeWidth: 6 }} x1="3" y1="0" x2="3" y2="90"/>
      <line fill="none" style={{ stroke: '#000000', strokeWidth: 3 }} x1="10.5" y1="0" x2="10.5" y2="90"/>
      <line fill="none" style={{ stroke: '#000000', strokeWidth: 3 }} x1="16.5" y1="0" x2="16.5" y2="90"/>
      <line fill="none" style={{ stroke: '#000000', strokeWidth: 9 }} x1="25.5" y1="0" x2="25.5" y2="90"/>
      <line fill="none" style={{ stroke: '#000000', strokeWidth: 3 }} x1="37.5" y1="0" x2="37.5" y2="90"/>
      <line fill="none" style={{ stroke: '#000000', strokeWidth: 21 }} x1="67.5" y1="0" x2="67.5" y2="90"/>
      <line fill="none" style={{ stroke: '#000000', strokeWidth: 9 }} x1="106.5" y1="0" x2="106.5" y2="90"/>
    </svg>
  </IconSpan>
);
